import type { AnkaufTransactionItemDto } from '../api';

interface ItemNamer {
    itemName: (key: string, snbt?: string | null) => string;
    stackName: (stack: { itemId: number; damage: number; snbt?: string }) => string;
}

// Names the stacks the seller handed over; a purchase recorded before those existed falls back to the
// offer that matched it.
export function ankaufItemsSummary(items: AnkaufTransactionItemDto[], namer: ItemNamer): string {
    return items.flatMap(i => i.stacks.length > 0
        ? i.stacks.map(s => namer.stackName({ itemId: s.itemId, damage: s.metadata, snbt: s.snbt ?? undefined }))
        : (i.itemKey ? [namer.itemName(i.itemKey, i.snbt)] : []))
        .join(', ');
}
